import { NgModule } from '@angular/core';
import { BrowserModule,Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from '../app.component';
import { ProgressbarComponent, RunReportComponent } from '../components';
import { ConfService } from 'src/conf.service';
import { HttpInterceptorService } from '../interceptors/http-interceptor.service';
import {EquipmentModule} from './equipment.module'
import { ServiceRequestModule } from './service-request.module';
import { AlertsModule } from './alerts.module';
import { AppRoutingModule } from '../routes/app-routing.module';
import { UsersModule } from './users.module';
import {CoreTemplateModule} from './core.module';
import { CommonModule, CurrencyPipe} from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {AuthCallBackComponent,ErrorComponent, HomeComponent, PageNotFoundComponent,LoaderComponent} from 'src/app/components'
import { UserIdleModule } from 'angular-user-idle';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [
    AppComponent,
    ProgressbarComponent,
    RunReportComponent,
    AuthCallBackComponent,
    ErrorComponent,
    HomeComponent,
    PageNotFoundComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,    
    CoreTemplateModule,
    ServiceRequestModule,
    AlertsModule,
    UsersModule,
    EquipmentModule,
    ScrollingModule,
    UserIdleModule.forRoot({idle: 3600, timeout: 1, ping: 0}),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: ConfService.conf.environment.production }),
    NgSelectModule,
  ],
  providers: [
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService, 
      multi: true // Set to false if you don't have another interceptor
    },
    Title,
  ],
  bootstrap: [AppComponent],
  //entryComponents: [TicketSummaryComponent]
})
export class AppModule { }
